import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import BookList from './components/BookList';
import Sidebar from './components/Sidebar';
import { getBooks, setDataIsLoaded } from './redux/actions';
import { ReduxState } from './types';
import './App.css';

// Fetch books
async function loadData(dispatch: ThunkDispatch<ReduxState, void, Action>) {
  await dispatch(getBooks());
  await dispatch(setDataIsLoaded());
}

function App() {
  const dispatch = useDispatch();
  const dataIsLoaded = useSelector((state: ReduxState) => state.dataIsLoaded);

  React.useEffect(() => {
    loadData(dispatch);
  }, [dataIsLoaded, dispatch]);

  return (
    <div className="App">
      <Sidebar />
      <BookList />
    </div>
  );
}

export default App;
